import { Info } from "lucide-react";

type NoticeBannerProps = {
  message: string;
};

// A state the operator should read, not act on. Issue #131 split "recommendations
// are withheld" into two reasons that ask opposite things — a freeze needs a
// human, an incomplete run needs nobody — and rendering the second one in the
// red `role="alert"` banner would undo the distinction the copy is making.
// `role="status"` is the same difference for a screen reader: announced
// politely, not as an alert interrupting whatever is being read.
export function NoticeBanner({ message }: NoticeBannerProps) {
  return (
    <div className="notice" role="status">
      <Info aria-hidden="true" size={18} />
      <span>{message}</span>
    </div>
  );
}
